export default "/images/supernatural-selection-button.png?eb335e8fc36561d86f5b65aabec99170";